import { Controller } from "@hotwired/stimulus";

// "Request payment" target toggle: bill an on-InfluenceKit brand (pick an
// accepted campaign) OR a brand that isn't on InfluenceKit yet (by email).
// Shows the matching field group and flips `required`/`disabled` so only the
// active target's inputs are submitted. Progressive enhancement — the server
// branches on the `target` param regardless, so the form is correct even if
// this never runs.
export default class extends Controller {
  static targets = [
    "campaignField",
    "emailField",
    "campaignInput",
    "emailInput",
    "payNow",
  ];

  connect() {
    this.update();
  }

  change() {
    this.update();
  }

  update() {
    const email = this.selectedTarget() === "email";

    this.campaignFieldTargets.forEach((f) =>
      f.classList.toggle("is-hidden", email)
    );
    this.emailFieldTargets.forEach((f) =>
      f.classList.toggle("is-hidden", !email)
    );

    this.campaignInputTargets.forEach((i) => {
      i.disabled = email;
      i.required = !email;
    });
    this.emailInputTargets.forEach((i) => {
      i.disabled = !email;
      i.required = email;
    });
    // "Pay now" is only meaningful for an on-platform payee — an off-platform
    // email payment has no payee to charge until it's claimed.
    this.payNowTargets.forEach((el) => el.classList.toggle("is-hidden", email));
  }

  selectedTarget() {
    const checked = this.element.querySelector('input[name="target"]:checked');
    return checked ? checked.value : "brand";
  }
}
